import CompanyContactListView from "@/views/company/contacts/CompanyContactListView";

export default [
  {
    name: "pages.company.contacts",
    path: "contacts",
    component: CompanyContactListView
  },
  
  
];
